import { Grid } from "@mui/material";
import * as React from "react";
import { required, SelectInput, TextInput } from "react-admin";
import { Edit, FormTab, TabbedForm } from "src/enterprise/ra-rbac";
import { StatusEnum } from "../../common/enum";
import Transformer from "../../common/Transformer";
import { NavigationEditComponent, ItemsButton } from "./";

export const NavigationEdit = () => {
  const transform = (data) => {
    Transformer(data, {
      remove: ["id", "createdAt", "updatedAt", "items"],
      update: {},
    });

    return data;
  };

  return (
    <Edit
      component={NavigationEditComponent}
      mutationMode="pessimistic"
      transform={transform}
    >
      <TabbedForm>
        <FormTab label="General" name="general">
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item sm={12} md={6}>
              <TextInput disabled source="id" />
            </Grid>
            <Grid item sm={12} md={6}>
              <TextInput source="name" validate={required()} />
            </Grid>
            <Grid item sm={12} md={6}>
              <SelectInput source="status" choices={StatusEnum} validate={required()} />
            </Grid>
            <Grid item sm={12}>
              <ItemsButton size="medium" variant="contained"/>
            </Grid>
          </Grid>
        </FormTab>
      </TabbedForm>
    </Edit>
  );
};
